export default "__VITE_ASSET__DT6kESOo__"